module.exports = __webpack_public_path__ + "img/heart_and_soul.a0c374d6.jpg";